import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'bb-line-text',
	templateUrl: './bb-line-text.component.html',
	styleUrls: ['./bb-line-text.component.scss']
})
export class BbLineTextComponent implements OnInit {
	constructor() { }

	ngOnInit(): void {	}
}
